import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

export interface InfoToastProps {
  message: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  iconClassName?: string;
  containerClassName?: string;
}

export const InfoToast: React.FC<InfoToastProps> = ({
  message,
  position = 'bottom',
  iconClassName = 'w-3.5 h-3.5 text-blue-500 hover:text-blue-600',
  containerClassName = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getPositionStyles = () => {
    switch (position) {
      case 'top':
        return 'bottom-full mb-1.5 left-1/2 -translate-x-1/2 items-center';
      case 'left':
        return 'right-full mr-1.5 top-1/2 -translate-y-1/2 items-end';
      case 'right':
        return 'left-full ml-1.5 top-1/2 -translate-y-1/2 items-start';
      case 'bottom':
      default:
        return 'top-full mt-1.5 left-0 items-start';
    }
  };

  return (
    <div className={`relative group inline-flex items-center ${containerClassName}`}>
      <button
        type="button"
        aria-label="Info"
        onClick={() => setIsOpen((prev) => !prev)}
        onBlur={() => setIsOpen(false)}
        className="focus:outline-none focus:ring-1 focus:ring-blue-400 rounded-full inline-flex items-center justify-center p-0.5"
      >
        <HelpCircle className={`cursor-pointer transition-colors ${iconClassName}`} />
      </button>
      <div
        className={`absolute ${getPositionStyles()} ${
          isOpen ? 'flex' : 'hidden'
        } group-hover:flex group-focus-within:flex flex-col z-50 pointer-events-none`}
      >
        <div className="bg-[#f6f6f6] text-black text-xs leading-tight font-normal rounded-md py-1 px-2.5 whitespace-nowrap shadow-sm border border-gray-200">
          {message}
        </div>
      </div>
    </div>
  );
};
